// ============================================================================
// BOYKOV-KOLMOGOROV - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'boykov-kolmogorov',
  name: 'Boykov-Kolmogorov',
  category: 'Graphs',
  complexity: {
    time: 'O(V²E)',
    space: 'O(V²)'
  },
  description: 'An efficient algorithm for computing the maximum flow in a graph. It uses augmenting paths and is particularly effective for computer vision applications like image segmentation.'
};
